"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FOUR_MINUTES_IN_MILLISECONDS = void 0;
const react_1 = require("@hot-observability-js/react");
const Settings_1 = __importDefault(require("configs/Settings"));
exports.FOUR_MINUTES_IN_MILLISECONDS = 240000;
const MAX_RECONNECT_COUNT = 6;
const RECONNECT_SLEEP_TIMEOUT = 1000;
class ClubWebSocket {
    constructor({ contextName, contextId, messageTimeout = exports.FOUR_MINUTES_IN_MILLISECONDS, onMessage, onError }) {
        this._socket = null;
        this._reconnectCount = 0;
        this._isConnectionOpen = false;
        this.connect = () => {
            var _a, _b, _c;
            this._socket = new WebSocket(this._url);
            this._reconnectCount++;
            (_a = this._socket) === null || _a === void 0 ? void 0 : _a.addEventListener('open', () => {
                this.logMessage('The WebSocket is connected!');
                this.startTimeout();
                this._isConnectionOpen = true;
            });
            (_b = this._socket) === null || _b === void 0 ? void 0 : _b.addEventListener('error', () => {
                if (!this._isConnectionOpen &&
                    this._reconnectCount <= MAX_RECONNECT_COUNT) {
                    this.sleep(RECONNECT_SLEEP_TIMEOUT);
                    this.logMessage(`${this._reconnectCount} of ${MAX_RECONNECT_COUNT}: trying to connect to websocket...`);
                    this.close();
                    this._socket = null;
                    this.connect();
                }
                else {
                    this.logMessage('There was an error connecting to the WebSocket!');
                    this.logSentryMessage('Error when trying to connect to WebSocket!');
                    this._onError();
                }
            });
            (_c = this._socket) === null || _c === void 0 ? void 0 : _c.addEventListener('message', ({ data }) => {
                this.logMessage('The WebSocket received a message!', data);
                const response = JSON.parse(data);
                this._onMessage(response);
            });
        };
        this.close = () => {
            var _a;
            (_a = this._socket) === null || _a === void 0 ? void 0 : _a.close();
            window.clearTimeout(this._messageTimeout);
            this.logMessage('The WebSocket was closed.');
        };
        this.startTimeout = () => {
            if (this._timeout) {
                this._messageTimeout = setTimeout(() => {
                    this.logMessage('Timeout waiting for WebSocket message!');
                    this.logSentryMessage('Timeout waiting for WebSocket message!');
                    this._onError();
                }, this._timeout);
            }
        };
        this.sleep = (millis) => {
            this.logMessage('Waiting to try a new WebSocket connection...');
            const stop = new Date().getTime();
            while (new Date().getTime() < stop + millis) { }
        };
        this.logMessage = (message, ...optionalParams) => {
            if (!Settings_1.default.isProduction()) {
                console.log(message, ...optionalParams);
            }
        };
        this.logSentryMessage = (message) => {
            react_1.HotmartRum.captureMessage(message, (scope) => {
                return scope.setContext('WebSocket', {
                    url: this._url
                });
            });
        };
        const queryParams = `?context=${contextName}&contextId=${contextId}`;
        this._url = `${Settings_1.default.api.clubWebSocket}${queryParams}`;
        this._onMessage = onMessage;
        this._onError = onError;
        this._timeout = messageTimeout;
        this.connect();
    }
}
exports.default = ClubWebSocket;
